const defaultImgPlaceholder = require("@root/assets/image/default_product_image_v2.png");

export const getImagePlaceholder = row => {
  const { mobileMediaLink, mediaLink } = row;

  return mobileMediaLink
    ? mobileMediaLink.split(",")[0]
    : mediaLink
    ? mediaLink.split(",")[0]
    : defaultImgPlaceholder;
};

export const batchGetImagePlaceholder = list => {
  return list.map(item => {
    return {
      ...item,
      imagePlaceholder: getImagePlaceholder(item)
    };
  });
};

export default getImagePlaceholder;
